import Validator from "../Validator";
import { flashMessagesSchema } from "./flashMessagesSchema";

export default class NotificationValidator extends Validator {

  public static async validate(data: any): Promise<boolean> {
    try {
      await flashMessagesSchema.validate(data);
      return true;
    } catch (error) {
      return false;
    }
  }

}
